import React, { useState } from 'react';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { useProjectModel } from '../../../model.js';
import { generateAppTools } from './generate.js';
import { ChooseNameStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateAppTools = () => {
  const { model } = useProjectModel();
  const [name, setName] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (name) {
      return generateAppTools(model.projectFolder, name);
    }
  }, [model.projectFolder, name]);

  return [
    <ChooseNameStep onSubmit={setName} name={name} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'app tools'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/overview/extensions-framework/backend-extensions/app-tools
        learnMoreUrl: 'https://wix.to/gcqQ9TF',
      })}
      route={name}
    />,
  ];
};
